import { mapValues } from 'lodash';
import { SetNullablesToOptionals } from '../types/types';

export const replaceObjectNullsWithUndefined = <T extends object>(obj: T): SetNullablesToOptionals<T> => {
    // @ts-ignore it is here because there is no way to have a generic type of the `value` depend on the value itself, so `mapValues` returns a value of type that has all the possible values types of T
    return mapValues(obj, (value) => (value === null ? undefined : value));
};

export const getLocalTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const getObjectKeys = <T extends object>(obj: T): (keyof T)[] => {
    return Object.keys(obj) as (keyof T)[];
};

// needed because Object.entries doesn't work with generics, this is a generic version of this method
export const getObjectEntries = <T extends object>(obj: T): [keyof T, T[keyof T]][] => {
    return Object.entries(obj) as [keyof T, T[keyof T]][];
};

export const addOrRemoveIfPresentFromArray = <T>(value: T, currentArray?: T[] | null): T[] => {
    if (!currentArray) return [value];
    
    if (currentArray.includes(value)) {
        return currentArray.filter(item => item !== value);
    }
    
    return [...currentArray, value];
};
export const splitArrayIntoBatches = <T,>(array: T[], batchSize: number): T[][] => {
    const batches: T[][] = [];
    for (let i = 0; i < array.length; i += batchSize) {
        batches.push(array.slice(i, i + batchSize));
    }
    return batches;
};